import React from 'react';
import { URL } from '../variables';
import { languages, languageOptions, getSelectedLanguage, setSelectedLanguage } from '../languages';
import Loader from '../components/Loader';

class SelectFaculdade extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      faculdades: [],
      faculdade_select: 'tete',
      loading: false,
      msgErro: '',
      redirect: false,
      theme: 'light',
      selectedLanguage: getSelectedLanguage()
    }
  }

  change_faculdade(event) {
    this.setState({ faculdade_select: event.target.value });

  }

  // renderRedirect = () => {
  //   if (this.state.redirect) {
  //     return <Redirect to={'/'+this.state.faculdade_select.slug} />
  //   }
  // }

  get_faculdades() {
    fetch(`${URL}api/corretor/get_faculdades`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',

        // 'Authorization': `Bearer ${this.props.token}`,
        // 'Content-Type': 'application/json',
      }
    }).then(async (responseLog) => {
      try {
        let resp = await responseLog.json();
        console.log(resp);
        if (resp.errors != null || resp.error != null) {
          let errors = Object.values(resp.errors);
          let erro = '';
          for (let i = 0; i < errors.length; i++) {
            if (i != errors.length - 1)
              erro += errors[i] + '\n';
            else
              erro += errors[i];
          }
          console.log(erro);

          this.setState({ loading: false, msgErro: erro, refresh: false, loadingMore: false });
        }
        else {
          let selected = '';
          if (resp.faculdades.length > 0) {

            selected = resp.faculdades[0].slug;
          }
          this.setState({ faculdades: resp.faculdades, loading: false, msgErro: '', faculdade_select: selected });
          // this.setState({ loading: false, refresh: false, loadingMore: false, msgErro: '' });

        }




      } catch (err) {
        console.log(err);
        this.setState({ loading: false, msgErro: 'Erro ao pegar resposta do servidor', refresh: false, loadingMore: false });

      }

    })
      .catch((err) => {
        console.log(err);
        this.setState({ loading: false, msgErro: 'Erro ao pegar resposta do servidor. Você está conectado a internet?', refresh: false, loadingMore: false });
      });
  }

  componentDidMount() {
    localStorage.setItem('correcao_theme', 'light');
    document.body.classList.remove('correcao-dark-theme');
    this.languageListener = () => this.setState({ selectedLanguage: getSelectedLanguage() });
    window.addEventListener('correcao_language_change', this.languageListener);
    this.setState({ loading: true, msgErro: '' });
    this.get_faculdades();
  }

  componentWillUnmount() {
    if (this.languageListener) {
      window.removeEventListener('correcao_language_change', this.languageListener);
    }
  }

  changeLanguage(event) {
    let selectedLanguage = setSelectedLanguage(event.target.value);
    this.setState({ selectedLanguage });
  }






  render() {
    console.log(this.state.faculdade_select)
    let t = languages[this.state.selectedLanguage] || languages.Pt;
    return (
      <div>
        {this.state.loading && <div className="correcao-loading-screen">
          <Loader title={t.loading_data} description={t.loading_hint} />
        </div>}
        {this.state.loading==false && <div id="app" className="correcao-select-page">
          <header className="correcao-select-header">
            <a className="logo"><img src={require('../assets/images/logo-ontest.png')} height="58" alt="logo" /></a>
            <div className="correcao-select-controls">
              <label className="correcao-preference-select compact">
                <i className="mdi mdi-web"></i>
                <select value={this.state.selectedLanguage} onChange={this.changeLanguage.bind(this)} aria-label={t.language_label} title={t.language_label}>
                  {languageOptions.map((item) => <option key={item.value} value={item.value}>{item.value}</option>)}
                </select>
              </label>
            </div>
          </header>

          <main className="correcao-select-main">
            <section className="correcao-select-card">
              <div className="correcao-select-copy">
                <span>{t.correction_brand}</span>
                <h1>{t.select_institution_title}</h1>
                <p>{t.select_institution_subtitle}</p>
              </div>

              <div className="correcao-select-list">
                {this.state.faculdades.map((item, id) => (
                  <a key={id} href={'/' + item.slug + '/login'} className="correcao-select-item">
                    <div className="correcao-select-logo">
                      <img src={item.logo} alt="logo" />
                    </div>
                    <div className="correcao-select-info">
                      <strong>{item.name}</strong>
                      <span>{t.access_correction_room}</span>
                    </div>
                    <div className="correcao-select-action">
                      <span>{t.access}</span>
                      <i className="mdi mdi-arrow-right"></i>
                    </div>
                  </a>
                ))}
                {this.state.faculdades.length == 0 && <div className="correcao-select-empty">
                  <i className="mdi mdi-clipboard-alert-outline"></i>
                  <p>{t.no_institution_available}</p>
                </div>}
              </div>
            </section>
          </main>
        </div>}
      </div>
    );
  }


}

export default SelectFaculdade;
